module.exports = __webpack_public_path__ + "img/43_58.a3751771.png";